import { useState, useEffect } from "react";
import ReactMde from "react-mde";
import { Labeled, ValidationError, useInput, required } from "react-admin";
import { Converter } from "showdown";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import "react-mde/lib/styles/css/react-mde-all.css";

const MarkdownInput = ({ label, ...props }) => {
  const { isRequired } = props;
  const {
    field,
    fieldState: { error },
  } = useInput(props);
  const [value, setValue] = useState(field.value || "");
  const [tab, setTab] = useState("write");
  const converter = new Converter({
    tables: true,
    simplifiedAutoLink: true,
    strikethrough: true,
    tasklists: true,
  });

  useEffect(() => {
    setValue(field.value);
    return () => {};
  }, [field.value]);

  const handleValueChange = val => {
    setValue(val);
    field.onChange(val);
    field.onBlur(val);
  };

  const handleTabChange = tabVal => {
    setTab(tabVal);
  };

  return (
    <Labeled label={label} isRequired={isRequired} fullWidth>
      <FormControl fullWidth>
        <ReactMde
          className="ra-input-mde"
          aria-describedby="markdown-Mde-error-text"
          onChange={val => handleValueChange(val)}
          onTabChange={tabVal => handleTabChange(tabVal)}
          value={value}
          generateMarkdownPreview={markdown =>
            Promise.resolve(converter.makeHtml(markdown))
          }
          selectedTab={tab}
          validate={required()}
        />
        {error && (
          <FormHelperText id="markdown-Mde-error-text" error>
            <ValidationError error={error.message} />
          </FormHelperText>
        )}
      </FormControl>
    </Labeled>
  );
};
export default MarkdownInput;
